import { canonicalClaims } from './claims';
import {
  canonicalPayors,
  canonicalStatuses,
  canonicalTariffs,
  payorRefs,
  statusRefs,
  tariffRefs,
} from './finance';
import {
  canonicalRoles,
  canonicalSites,
  organizationRefs,
  roleRefs,
  siteRefs,
} from './organizations';
import {
  canonicalHealthcards,
  canonicalPatients,
  canonicalProviders,
  canonicalUsers,
  healthcardRefs,
  patientRefs,
  providerRefs,
  userRefs,
} from './people';
import { canonicalSubmissionByID } from './submissions';

export {
  deriveFixtureForeignKeys,
  normalizeClaim,
  normalizeHealthcard,
  normalizePatient,
  normalizeProvider,
  normalizeRole,
  normalizeSite,
  normalizeSubmission,
  normalizeUser,
  type CanonicalClaim,
  type CanonicalDebit,
  type CanonicalRole,
  type CanonicalSubmission,
  type FixtureRecord,
} from './shared';

export {
  canonicalOrganizations,
  canonicalRoles,
  canonicalSites,
  organizationRefs,
  roleRefs,
  siteRefs,
} from './organizations';
export {
  canonicalHealthcards,
  canonicalPatients,
  canonicalProviders,
  canonicalUsers,
  healthcardRefs,
  patientRefs,
  providerRefs,
  userRefs,
} from './people';
export {
  canonicalPayors,
  canonicalStatuses,
  canonicalTariffs,
  claimStatusValues,
  payorRefs,
  statusRefs,
  tariffRefs,
} from './finance';
export { canonicalSubmissions } from './submissions';
export { canonicalClaims } from './claims';

export const defaultOrganization = organizationRefs.winnipegJets;
export const defaultRole =
  canonicalRoles.find((role) => role.id === roleRefs.winnipegJetsAdmin.id)!;
export const defaultSite =
  canonicalSites.find((site) => site.id === siteRefs.canadaLifeCentre.id)!;
export const defaultUser =
  canonicalUsers.find((user) => user.id === userRefs.kyleConnor.id)!;
export const defaultProvider =
  canonicalProviders.find(
    (provider) => provider.id === providerRefs.normanSilver.id
  )!;
export const defaultPatient =
  canonicalPatients.find((patient) => patient.id === patientRefs.adamLowry.id)!;
export const defaultHealthcard = canonicalHealthcards.find(
  (healthcard) => healthcard.id === healthcardRefs.adamLowryPrimary.id
)!;
export const defaultStatus =
  canonicalStatuses.find((status) => status.id === statusRefs.ready.id)!;
export const defaultPayor =
  canonicalPayors.find((payor) => payor.id === payorRefs.mb.id)!;
export const defaultTariff =
  canonicalTariffs.find((tariff) => tariff.id === tariffRefs.testing8442.id)!;
export const defaultSubmission = canonicalSubmissionByID.get(
  'd2a97903-066e-42a5-aff0-4aadffca0da0'
)!;
export const defaultClaim = canonicalClaims[0];
